import { set } from "lodash";
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  STORE_TOKEN,
  SAVE_USER_DETAILS,
  SET_ADDRESS_BOOK,
  SET_DEFAULT_ADDRESS,
  SHOW_PREVIEW,
  SET_PREV_PATH,
  STORE_TOKEN_CHECKOUT_GUEST,
  RESET_TOKEN_CHECKOUT_GUEST,
  SET_EMAIL,
  SET_AUTH_DATA,
  RESET_AUTH_DATA,
  SET_EMAIL_OTP_DATA,
  CLEAR_EMAIL_OTP_DATA,
  SAVE_UPDATE_DETAILS_DATA,
  RESET_UPDATE_DETAILS_DATA,
  SET_TURNSTILE_CAPTCHA_TOKEN
} from "../constants";

type AuthState = {
  turnstileCaptchaToken: string;
  userName: string;
  customerId: string;
  userLoggedIn: boolean;
  accessToken: string;
  accessGuestToken: string;
  addressBook: any[];
  showPreview: boolean;
  BFLUser: boolean;
  profileCompletionPercentage?: number;
  email: string;
  prevPath?: string;
  countryId?: string;
  firstname: string;
  lastname?: string;
  isMobileVerified?: boolean;
  phone?: string;
  authData: {
    email?: string;
    token?: string;
    signInOptions?: string[];
    emailOtpToken: string;
    emailOtpRetryAfterSeconds: number;
    emailOtpMaskedPhone: string;
  };
  responseUpdateDetailsData: any;
};

const initialState: AuthState = {
  turnstileCaptchaToken: "",
  userName: "",
  firstname: "",
  customerId: "",
  userLoggedIn: false,
  accessToken: "",
  accessGuestToken: "",
  addressBook: [],
  showPreview: false,
  BFLUser: false,
  email: "",
  authData: {
    email: "",
    token: "",
    signInOptions: null,
    emailOtpToken: "",
    emailOtpRetryAfterSeconds: null,
    emailOtpMaskedPhone: ""
  },
  responseUpdateDetailsData: null
};

const saveUserDetails = (state: AuthState, { data }) => ({
  ...state,
  userName: data.message,
  accessToken: data.token || data.accessToken,
  customerId: data.customerId || state.customerId,
  userLoggedIn: true,
  prevPath: "",
  BFLUser: data.BFLUser
});

const storeToken = (state: AuthState, { token }) => ({
  ...state,
  accessToken: token,
  userLoggedIn: true
});
const storeTokenCheckoutGuest = (state: AuthState, { token }) => ({
  ...state,
  accessGuestToken: token,
  userLoggedIn: false
});
const resetTokenCheckoutGuest = (state: AuthState) => ({
  ...state,
  accessGuestToken: ""
});

const setPreviewMode = (state: AuthState, { value }) => ({
  ...state,
  showPreview: value
});

const setTurnstileCaptchaToken = (state: AuthState, action) => ({
  ...state,
  turnstileCaptchaToken: action.payload
});

const setUserInfo = (
  state: AuthState,
  { userProfile: { fname, ...rest } }
) => ({
  ...state,
  userName: fname,
  ...rest
});

const setAddressBook = (state: AuthState, { addressBook = [] }) => ({
  ...state,
  addressBook
});

const setPrevPath = (state: AuthState, { prevPath }) => ({
  ...state,
  prevPath
});

const setDefaultAddress = (state: AuthState, { name, value, index }) => ({
  ...state,
  addressBook: [
    ...state.addressBook.slice(0, index),
    {
      ...state.addressBook[index],
      [name]: value
    },
    ...state.addressBook.slice(index + 1)
  ]
});

const setEmail = (state: AuthState, action) => ({
  ...state,
  email: action.payload
});

const setAuthData = (state: AuthState, action) => ({
  ...state,
  authData: action.payload
});

const resetAuthData = (state: AuthState, action) => ({
  ...state,
  authData: {
    email: "",
    token: "",
    signInOptions: null,
    emailOtpToken: "",
    emailOtpRetryAfterSeconds: null,
    emailOtpMaskedPhone: ""
  }
});

const setOtpAuthData = (state: AuthState, action) => ({
  ...state,
  authData: {
    ...state.authData,
    emailOtpToken: action.payload.emailOtpToken,
    emailOtpRetryAfterSeconds: action.payload.emailOtpRetryAfterSeconds,
    emailOtpMaskedPhone: action.payload.emailOtpMaskedPhone
  }
});

const resetOtpAuthData = (state: AuthState) => {
  return {
    ...state,
    authFlow: {
      ...state.authData,
      emailOtpToken: "",
      emailOtpRetryAfterSeconds: 60,
      emailOtpMaskedPhone: ""
    }
  };
};

const saveResponseUpdateDetailsData = (state: AuthState, action) => ({
  ...state,
  responseUpdateDetailsData: action.payload
});

const resetResponseUpdateDetailsData = (state: AuthState) => ({
  ...state,
  responseUpdateDetailsData: null
});

const userProfileReducer = (
  state: AuthState = initialState,
  action
): AuthState => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return saveUserDetails(state, action);
    case STORE_TOKEN:
      return storeToken(state, action);
    case SET_TURNSTILE_CAPTCHA_TOKEN:
      return setTurnstileCaptchaToken(state, action);
    case STORE_TOKEN_CHECKOUT_GUEST:
      return storeTokenCheckoutGuest(state, action);
    case RESET_TOKEN_CHECKOUT_GUEST:
      return resetTokenCheckoutGuest(state);
    case SAVE_USER_DETAILS:
      return setUserInfo(state, action);
    case SET_ADDRESS_BOOK:
      return setAddressBook(state, action);
    case SET_DEFAULT_ADDRESS:
      return setDefaultAddress(state, action);
    case SHOW_PREVIEW:
      return setPreviewMode(state, action);
    case SET_PREV_PATH:
      return setPrevPath(state, action);
    case SET_EMAIL:
      return setEmail(state, action);
    case SET_AUTH_DATA:
      return setAuthData(state, action);
    case RESET_AUTH_DATA:
      return resetAuthData(state, action);
    case SET_EMAIL_OTP_DATA:
      return setOtpAuthData(state, action);
    case CLEAR_EMAIL_OTP_DATA:
      return resetOtpAuthData(state);
    case LOGOUT_SUCCESS:
      return initialState;
    case SAVE_UPDATE_DETAILS_DATA:
      return saveResponseUpdateDetailsData(state, action);
    case RESET_UPDATE_DETAILS_DATA:
      return resetResponseUpdateDetailsData(state);
    default:
      return state;
  }
};

export default userProfileReducer;
